import React from "react";
import Hero from "../components/Hero";
import BioSection from "../components/BioSection";
import Timeline from "../components/Timeline";
import ProjectsBento from "../components/ProjectsBento";
import NewsGrid from "../components/NewsGrid";
import InstagramGrid from "../components/InstagramGrid";
import ParticipateForm from "../components/ParticipateForm";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <BioSection />
      <ProjectsBento limit={8} />
      <Timeline limit={6} />
      <NewsGrid limit={3} />
      <InstagramGrid />
      <ParticipateForm />
    </div>
  );
}
